module.exports = __webpack_public_path__ + "img/ic_20_google.06cc3496.svg";